/* src/app/pages/casos/paso2/paso2.component.scss */
/*# sourceMappingURL=paso2.component.css.map */
